import React from "react";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { LanguageProvider } from "@/context/LanguageContext";
import ProtectedRoute from "@/components/layout/ProtectedRoute";
import AppLayout from "@/components/layout/AppLayout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Units from "@/pages/Units";
import UnitDetail from "@/pages/UnitDetail";
import EstimationFormPage from "@/pages/EstimationFormPage";
import EstimationDetail from "@/pages/EstimationDetail";
import Users from "@/pages/Users";
import Settings from "@/pages/Settings";
import MechanicPricing from "@/pages/MechanicPricing";
import "@/App.css";

const Shell = () => (
  <ProtectedRoute>
    <AppLayout>
      <Outlet />
    </AppLayout>
  </ProtectedRoute>
);

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<Shell />}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/units" element={<Units />} />
              <Route path="/units/:id" element={<UnitDetail />} />
              <Route path="/estimation/view/:id" element={<EstimationDetail />} />
              <Route path="/estimation/:category" element={<EstimationFormPage />} />
              <Route path="/mechanic-pricing" element={<MechanicPricing />} />
              <Route path="/settings" element={<Settings />} />
            </Route>
            <Route
              path="/users"
              element={
                <ProtectedRoute adminOnly>
                  <AppLayout>
                    <Users />
                  </AppLayout>
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
